import axios from "axios";

export async function SendSms(to, message) {
    try {
        const response = await axios.post(
            "https://api-a5s6jl62ja-uc.a.run.app/send-sms",
            { to, message }
        );
        console.log("SMS sent:", response.data);
    } catch (error) {
        console.error("Error sending SMS:", error);
        throw error;
    }
}
